import React from 'react';
import HelpCenterTabs from '../../components/HelpCenterTabs';
import './Tutorials.css';

const TUTORIAL_METRICS = [
  { label: 'Guías en desarrollo', value: '14' },
  { label: 'Usuarios inscritos al piloto', value: '120+' },
  { label: 'Tiempo promedio por módulo', value: '6 min' },
];

const TUTORIAL_TRACKS = [
  {
    title: 'Primeros pasos',
    description: 'Configura tu empresa, invita al equipo y publica tu primer inventario.',
    bullets: [
      'Checklist de activacion Express (cliente y proveedor).',
      'Carga masiva de unidades con plantillas validadas.',
      'Definicion de roles y politicas internas.',
    ],
  },
  {
    title: 'Operaciones diarias',
    description: 'Domina el panel para monitorear solicitudes y negociar oportunidades.',
    bullets: [
      'Uso del feed colaborativo y etiquetas.',
      'Alertas inteligentes segun estado de unidad.',
      'Mejores practicas para responder cotizaciones.',
    ],
  },
  {
    title: 'Contenido comercial',
    description: 'Optimiza publicaciones, multimedia y documentos antes de salir al marketplace.',
    bullets: [
      'Plantillas para fichas tecnicas y banner corporativo.',
      'Control de disponibilidad y calendario.',
      'Versionado de documentos y evidencias.',
    ],
  },
];

const TUTORIAL_ROADMAP = [
  {
    title: 'Integraciones y API',
    detail: 'Webhooks para oportunidades y sincronizacion con ERP/CRM.',
  },
  {
    title: 'Automatizaciones financieras',
    detail: 'Exportaciones programadas, conciliaciones y recordatorios de cobranza.',
  },
  {
    title: 'Playbooks comerciales',
    detail: 'Secuencias sugeridas para prospectar y dar seguimiento a clientes enterprise.',
  },
];

export default function Tutorials() {
  return (
    <>
      <HelpCenterTabs />
      <main className="tutorials-page">
      <header className="tutorials-page__hero">
        <div className="tutorials-page__intro">
          <span className="tutorials-page__kicker">Centro de ayuda</span>
          <h1 className="tutorials-page__title">Tutoriales Flotte</h1>
          <p className="tutorials-page__subtitle">
            Lanzamos un hub compacto con guias accionables, videos cortos y checklists descargables.
            Es el complemento ideal de las sesiones de onboarding para que cualquier rol avance sin
            depender de soporte.
          </p>
        </div>

        <ul className="tutorials-page__meta">
          {TUTORIAL_METRICS.map(metric => (
            <li key={metric.label}>
              <span className="tutorials-page__meta-label">{metric.label}</span>
              <strong className="tutorials-page__meta-value">{metric.value}</strong>
            </li>
          ))}
        </ul>

        <div className="tutorials-page__cta">
          <a className="tutorials-page__primary" href="mailto:soporte@flotte.mx">
            Reserva tu acceso anticipado
          </a>
          <span className="tutorials-page__hint">Respondemos en menos de 1 dia habil.</span>
        </div>
      </header>

      <section className="tutorials-page__section">
        <div className="tutorials-page__section-head">
          <div>
            <span className="tutorials-page__eyebrow">Rutas guiadas</span>
            <h2>Contenido compacto por rol</h2>
          </div>
          <p>
            Cada ruta combina articulos, videos y ejercicios descargables. Los materiales se alojan
            en Notion y puedes integrarlos a tus wikis internas.
          </p>
        </div>

        <div className="tutorials-page__grid">
          {TUTORIAL_TRACKS.map(track => (
            <article key={track.title} className="tutorials-page__card">
              <div className="tutorials-page__card-head">
                <h3>{track.title}</h3>
                <p>{track.description}</p>
              </div>
              <ul>
                {track.bullets.map(item => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <section className="tutorials-page__section tutorials-page__section--muted">
        <div className="tutorials-page__section-head">
          <div>
            <span className="tutorials-page__eyebrow">Hoja de ruta</span>
            <h2>Lo que viene</h2>
          </div>
          <p>
            Priorizamos tutoriales segun los retos que escuchamos en el canal de Customer Success.
            Si necesitas algo especifico, cuentanos y lo sumamos al backlog.
          </p>
        </div>

        <div className="tutorials-page__roadmap">
          {TUTORIAL_ROADMAP.map(item => (
            <article key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.detail}</p>
            </article>
          ))}
        </div>

        <div className="tutorials-page__contribute">
          <div>
            <h3>Comparte tu caso</h3>
            <p>
              Escríbenos a <a href="mailto:soporte@flotte.mx">soporte@flotte.mx</a> o abre un ticket
              en el dashboard (Soporte → Nuevo). Convertimos tus flujos en tutoriales reutilizables
              para toda la red.
            </p>
          </div>
          <a className="tutorials-page__secondary" href="/dashboard?section=support-new">
            Enviar solicitud
          </a>
        </div>
      </section>
    </main>
    </>
  );
}
